export enum PaymentProvider {
	Stripe = "stripe",
	Prodamus = "prodamus",
	Unknown = "unknown",
}

export enum PaymentVerifyStatus {
	Idle = "idle",
	Verifying = "verifying",
	Success = "success",
	Pending = "pending",
	Failed = "failed",
}
